<template>
  <v-dialog v-model="dialogOrganisation" max-width="450px">
    <template v-slot:activator="{ props }">
      <slot name="activator" :props="props">
        <v-btn
          v-bind="props"
          variant="flat"
          size="large"
          class="mb-2"
          :disabled="subscriptionAccessType !== 'FULL'"
        >
          <v-icon class="mr-2">mds:add</v-icon>
          New Organization
        </v-btn>
      </slot>
    </template>

    <v-card>
      <v-container fluid justify-space-between align-top class="d-flex flex-row">
        <v-card-title class="flex-grow-1">
          <h5 v-if="editOrganisation && editOrganisation.id" class="text-h5">Edit Organization</h5>
          <h5 v-else class="text-h5">New Organization</h5>
        </v-card-title>

        <div class="flex-shrink-1">
          <v-btn variant="text" icon color="grey" @click="closeOrganisation">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
      </v-container>
      <v-container grid-list-md class="py-0">
        <v-form ref="formOrganisation" fast-fail @submit.prevent v-model="validOrganisation">
          <v-row wrap>
            <v-col xs12>
              <v-text-field
                name="organisation-name-input"
                ref="organisationNameInput"
                v-model="editOrganisation.name"
                :rules="[rules.required, rules.counter]"
                label="Organization name"
                validate-on="blur"
                v-on:keyup.enter="saveOrganisation"
                :autofocus="true"
                variant="outlined"
                density="default"
              >
              </v-text-field>
              <!-- keyup.enter doesn't work without this row, seems like a bug in vue or vuetify -->
              <v-text-field class="hidden" :disabled="true" style="display: none;"></v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
      <v-card-actions class="justify-end pt-4">
        <v-btn rounded="lg" size="large" variant="outlined" color="gray" @click="closeOrganisation">Cancel</v-btn>
        <v-btn rounded="lg" size="large" variant="flat" color="primary" id="change-password"
               @click="saveOrganisation">{{ editOrganisation && editOrganisation.id ? 'Update' : 'Add' }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import projectApi from '@/api/projectApi'
import store from '@/store'
import { mapState } from 'vuex'

export default {
  props: {
    buttonText: {
      type: String,
      default: 'Add organization'
    },
    buttonTheme: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    dialogOrganisation: false,
    validOrganisation: true,
    rules: {
      required: value => !!value || 'Required.',
      counter: value => (value && value.length <= 30) || 'Max 30 characters'
    },
    editOrganisation: {
      name: ''
    }
  }),
  methods: {
    async saveOrganisation () {
      const result = await this.$refs.formOrganisation.validate()
      if (result.valid) {
        if (this.editOrganisation.id) {
          // update organisation
          const index = this.organisations.findIndex(org => org.name === this.editOrganisation.name && org.userId === store.state.userId)
          if (index >= 0) {
            alert('This organization already exists.')
          } else {
            projectApi.updateOrganisation(this.editOrganisation)
            this.closeOrganisation()
          }
        } else {
          // create new organisation
          const index = this.organisations.findIndex(org => org.name === this.editOrganisation.name && org.userId === store.state.userId)
          if (index >= 0) {
            alert('This organization already exists.')
          } else {
            projectApi.createOrganisation(this.editOrganisation)
            this.closeOrganisation()
          }
        }
      }
    },
    closeOrganisation () {
      this.dialogOrganisation = false
    },
    openOrganisationDialog () {
      this.dialogOrganisation = true
    },
    setItem (item) {
      this.editOrganisation = item
    },
    selectAllTextInInput () {
      const inputElement = this.$refs.organisationNameInput.$el.querySelector('input')
      inputElement.focus()
      inputElement.select()
    }
  },
  computed: {
    ...mapState({
      organisations: state => state.organisations.organisations || [],
      currentUser: state => state.user.user,
      subscriptionAccessType: state => state.payments.subscriptionAccessType
    })
  },
  watch: {
    dialogOrganisation (val) {
      if (!val) {
        this.editOrganisation = {
          name: ''
        }
      } else {
        if (!this.editOrganisation || !this.editOrganisation.id) {
          this.$refs.formOrganisation && this.$refs.formOrganisation.reset()
          this.editOrganisation = {
            name: this.organisations?.length > 0 ? '' : this.currentUser?.firstname + "'s organization" // eslint-disable-line
          }
          this.$nextTick(() => {
            this.selectAllTextInInput()
          })
        }
      }
    }
  }
}
</script>
